module.exports = __webpack_public_path__ + "img/pumpcharge-logo-blue.92d814d6.png";